/**
 * Maps Login / LoginSelectEnvironment UI kit label ids to legacy backend i18n keys.
 * UI ids do not always match backend keys; this keeps existing translations aligned.
 */
export const LOGIN_LABELS_KEYS = {
    documentTypeAndNumber: "login.step1.documentType.label",
    user: "login.step1.username.label",
    rememberDocumentUser: "login.step1.rememberDocumentAndUser.label",
    rememberUser: "login.step1.rememberUser.label",
    continue: "global.continue",
    "recover.user": "login.step1.recoveryUser.header",
    password: "login.step2.password.label",
    "recover.password": "login.step2.forgotPassword",
    "submit.1": "login.nextStep",
    "submit.2": "login.comeIn",
    "change.document.user": "login.step1.areNotYou",
    "ask.security.seal": "login.step2.textSeal",
    "ask.security.seal.description": "login.step2.verifyYourImage",
    biometric: "biometrics.login",
    "with.password": "login.step1.withPassword",
    "change.logged.user": "login.step1.forget",
    token: "settings.token.login.button",
    requestAccount: "login.step1.requestAccount",
    simulate: "login.step1.simulate.label",
};

export const LOGIN_TEXT_KEYS = {
    welcome: "login.step1.welcome",
    welcomeWithUser: "login.step1.welcomeWithUser",
    "ask.security.seal": "login.step2.textSeal",
    "ask.security.seal.description": "login.step2.verifyYourImage",
    noAccount: "login.step1.noAccount",
    haveFixedTerm: "login.step1.haveFixedTerm",
};

export const LOGIN_SELECT_ENV_LABELS_KEYS = {
    rememberEnvironment: "login.step3.rememberEnvironment.label",
    submit: "login.comeIn",
};

export const LOGIN_ACCEPT_TOC_LABELS_KEYS = {
    title: "login.step4.termsAndCondiciones.label",
    download: "global.download",
    decline: "login.step4.declineTerms.label",
    accept: "login.step4.acceptTerms.label",
};
